module.exports = __webpack_public_path__ + "assets/img/7dd7142.e421f46d.svg";